import axios, { AxiosResponse } from 'axios';
import { mutate } from 'swr';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';
import { withQueryParams } from '@shared/commonFunctions';
import { IUserGoals } from '../Tracker/interfaces';

const USER_PATH = `/${SERVICES.USER}`;

export const requestGetUserGoals = (goalsUserId: string, periodId: string) => {
    const url =  withQueryParams(`/${SERVICES.USER}/user-goals`, { userId: goalsUserId, periodId }, false);

    return mutate(url, async() => {
        try {
            const response: AxiosResponse<IUserGoals[]> = await axios.get(url);
            
            return response.data;
        } catch (err) {
            Notistack.generalError(getError(err));
        }
    });
};

export const requestSaveUserGoals = (request: IUserGoals) => {
    const url = `${USER_PATH}/user-goals`;

    return mutate(url, async() => {
        try {
            await axios.post(url, request);
            Notistack.successMessage('Goals - Saved Successfully');
        } catch (err) {
            Notistack.generalError(getError(err));
        }
    });
};

export const requestUpdateUserGoals = (request: IUserGoals, goalId?: string) => {
    const url = `${USER_PATH}/user-goals/${goalId}`;

    return mutate(url, async() => {
        try {
            await axios.put(url, request);
            Notistack.successMessage('Goals - Saved Successfully');
        } catch (err) {
            Notistack.generalError(getError(err));
        }
    });
};